import { Button } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import type { TLandingCta } from '../landing-content';
import { landingPalette } from '../landing-theme';
import { trackLandingCta } from '../track-landing-cta';

type TVariant = 'primary' | 'outline' | 'ghost';

const variantStyles: Record<TVariant, SxProps<Theme>> = {
  primary: { bgcolor: '#ffffff', color: '#090909', '&:hover': { bgcolor: '#ffffff' } },
  outline: {
    bgcolor: 'transparent',
    border: '1px solid rgba(255,255,255,.35)',
    color: 'text.primary',
    '&:hover': { bgcolor: 'rgba(255,255,255,.08)' },
  },
  ghost: {
    bgcolor: 'transparent',
    border: '1px solid rgba(255,255,255,.14)',
    color: 'text.primary',
    '&:hover': { bgcolor: 'rgba(255,255,255,.08)' },
  },
};

/** Pill CTA that renders as an anchor and reports the click to GA4. */
export function LandingCtaButton(props: {
  cta: TLandingCta;
  variant: TVariant;
  sx?: SxProps<Theme>;
}) {
  return (
    <Button
      href={props.cta.href}
      aria-label={props.cta.ariaLabel}
      target="_blank"
      rel="noopener noreferrer"
      variant="text"
      disableElevation
      onClick={() => trackLandingCta(props.cta.analyticsId)}
      sx={[
        {
          // A string, not `999`: the numeric form is multiplied by `shape.borderRadius`
          // (12) and emitted as `11988px`. Same pill, explicit intent.
          borderRadius: '999px',
          minHeight: { xs: 42, sm: 46 },
          px: { xs: 2, sm: 2.5 },
          fontWeight: 700,
          fontFamily: 'inherit',
          transition: 'transform .2s ease',
          '&:hover': { transform: 'translateY(-2px)' },
          '@media (max-width:640px)': { fontSize: '.88rem' },
          '&.Mui-focusVisible': {
            outline: `2px solid ${landingPalette.accent}`,
            outlineOffset: 2,
          },
        },
        variantStyles[props.variant],
        ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : []),
      ]}
    >
      {props.cta.label}
    </Button>
  );
}
